export default __webpack_public_path__ + "static/ing-b1ba83e3a0f9ab8b2bf0b55b515bcbfe.svg";